module.exports = __webpack_public_path__ + "img/result-03.b6b7dc86.jpg";